import { render, staticRenderFns } from "./QuestionMarkCta.vue?vue&type=template&id=72d0fd1a&scoped=true&"
import script from "./QuestionMarkCta.vue?vue&type=script&lang=js&"
export * from "./QuestionMarkCta.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMarkCta.vue?vue&type=style&index=0&id=72d0fd1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d0fd1a",
  null
  
)

export default component.exports